import { Center, Text, VStack } from "@chakra-ui/react";

export default function BrokenPage() {
  return (
    <Center minH={"100vh"}>
      <VStack maxW={"460px"}>
        <div>
          <svg
            data-v-ad307406=""
            xmlns="http://www.w3.org/2000/svg"
            height="3rem"
            width="3rem"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M15.236 22a3 3 0 0 0-2.2-5"></path>
            <path d="M16 20a3 3 0 0 1 3-3h1a2 2 0 0 0 2-2v-2a4 4 0 0 0-4-4V4"></path>
            <path d="M18 13h.01"></path>
            <path d="M18 6a4 4 0 0 0-4 4 7 7 0 0 0-7 7c0-5 4-5 4-10.5a4.5 4.5 0 1 0-9 0 2.5 2.5 0 0 0 5 0C7 10 3 11 3 17c0 2.8 2.2 5 5 5h10"></path>
          </svg>
        </div>
        <Text
          fontSize={{ base: "24px", lg: "32px" }}
          textAlign={"center"}
          mb={3}
          fontWeight={600}
        >
          Something is broken, <br />
          please refresh, contact support or
        </Text>

        <a href="/" className="font-semibold text-green-700 text-lg">
          Return Home
        </a>
      </VStack>
    </Center>
  );
}
